<template>
    <RadioGroup
        @update:modelValue="$emit('update:modelValue', $event)"
        class="col-span-6">
        <RadioGroupLabel class="sr-only">
            {{ label }}
        </RadioGroupLabel>
        <div class="bg-white rounded-md -space-y-px">
            <RadioGroupOption as="template" v-for="(item, itemIdx) in items" :key="item[key]"
                              :value="item" v-slot="{ checked, active }">
                <div
                    :class="[itemIdx === 0 ? 'rounded-tl-md rounded-tr-md' : '', itemIdx === items.length - 1 ? 'rounded-bl-md rounded-br-md' : '', checked ? 'bg-lime-100 border-lime-200 z-10' : 'border-gray-200', 'relative border p-4 flex cursor-pointer focus:outline-none']">
                                <span
                                    :class="[checked ? 'bg-lime-600 border-transparent' : 'bg-white border-gray-300', active ? 'ring-2 ring-offset-2 ring-lime-500' : '', 'h-4 w-4 mt-0.5 cursor-pointer rounded-full border flex items-center justify-center']"
                                    aria-hidden="true">
                                    <span class="rounded-full bg-white w-1.5 h-1.5" />
                                </span>
                    <div class="ml-3 flex flex-col">
                        <RadioGroupLabel as="span"
                                         :class="[checked ? 'text-lime-900' : 'text-gray-900', 'block text-sm font-medium']">
                            {{ item[name] }}
                        </RadioGroupLabel>
                        <RadioGroupDescription as="span"
                                               v-if="item.description"
                                               :class="[checked ? 'text-lime-700' : 'text-gray-500', 'block text-sm']">
                            {{ item.description }}
                        </RadioGroupDescription>
                    </div>
                </div>
            </RadioGroupOption>
        </div>
    </RadioGroup>
</template>

<script>
import { RadioGroup, RadioGroupDescription, RadioGroupLabel, RadioGroupOption } from "@headlessui/vue";

export default {
    props: {
        label: String,
        items: Array,
        key: {
            type: String,
            default: "code"
        },
        name: {
            type: String,
            default: "name"
        }
    },
    emits: ["update:modelValue"],
    components: {
        RadioGroup,
        RadioGroupOption,
        RadioGroupDescription,
        RadioGroupLabel
    }
};
</script>

<style scoped>

</style>
